import Form, { formCreate } from '../../../../../../components/form';
import CostBudget, { RebateDetailList, ShareList } from '../../../../components';
import request from '../../../../../../utils/request';

formCreate.component('CostBudget', CostBudget);
formCreate.component('RebateDetailList', RebateDetailList);
formCreate.component('ShareList', ShareList);

export default {
  extends: Form,
  components: {
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      formParentCode: 'CRM20210429000001597',
      formFunctionCode: 'tpm_promotion_policy_form',
      buttonText: {
        submit: '保存',
      },
      buttons: {
        submitAudit: this.formConfig.code !== 'view',
      },
    };
  },
  methods: {
    // 设置rule
    setRule(item) {
      const v = item;
      if (v.field === 'beginDate' || v.field === 'endDate') {
        v.props = {
          ...v.props,
          type: 'datetime',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          relation: {
            beginField: 'beginDate',
            endField: 'endDate',
            gtNow: true,
          },
        };
      } else if (v.field === 'budgetSubjectCode') {
        v.props = {
          ...v.props,
          params: {
            functionCode: 'tpm_promotion_subject_list',
          },
          getValue: (field) => this.getFieldValue(field),
          state: this.formConfig.budgetState,
        };
      } else if (v.field === 'categoriesCode') {
        v.restful = '/tpm/tpmActController/getCategoriesByBudget';
        v.restfulParams = {
          enableStatus: '009',
          actType: 'department_charge',
        };
        v.restfulParamsGetValue = { controlIds: 'controlIds' };
        v.optionsKey = { label: 'categoriesName', value: 'categoriesCode' };
        v.refresh = true;
      } else if (v.field === 'detailVos') {
        v.props = {
          ...v.props,
          functionCode: 'tpm_promotion_detail_list',
          getValue: (field) => this.getFieldValue(field),
        };
        v.value = [];
      }
      return v;
    },

    // 表单渲染完成后的回调
    formComplete() {
      const budgetSubjectCode = this.getRule('budgetSubjectCode');
      budgetSubjectCode.on.change = (e) => {
        let budgetControlVos = [];
        if (e) {
          budgetControlVos = e.map((v) => ({
            ...v,
            feeBudgetVos: v.feeBudgetVos.map((sub) => ({
              ...sub,
              reduceOrder: 1,
            })),
          }));
        }
        this.setValue({
          controlIds: e ? e.map((v) => v.id) : [],
          budgetSubjectCode: e ? e[0].feeBudgetCodes : '',
          budgetSubjectName: e ? e[0].budgetSubjectsName : '',
          categoriesCode: '',
          availableBalance: e ? e[0].canUseAmount : undefined,
          budgetControlVos,
        });
        this.disabled(!e, 'categoriesCode');
      };
      const beginDate = this.getRule('beginDate');
      const endDate = this.getRule('endDate');
      beginDate.on.change = this.changFn;
      endDate.on.change = this.changFn;

      const categoriesCode = this.getRule('categoriesCode');
      categoriesCode.on.change = (e) => {
        this.setValue({
          detailVos: [],
        });
      };

      if (this.formConfig.code === 'edit' || this.formConfig.code === 'view') {
        console.log('编辑或查看');
        // request.get('/tpm/tpmBudgetSubjectsController/query', {
        //   id: this.formConfig.row.id,
        //   directSystemId: this.formConfig.row.directSystemId,
        //   directSystemName: this.formConfig.row.directSystemName,
        // }).then((res) => {
        //   if (res.success) {
        //     this.setValue(res.result);
        //   }
        // });
      }
    },
    // 日期重置编辑信息
    changFn(e) {
      if (this.formConfig.budgetState === 'current') {
        this.setValue({
          controlIds: [],
          budgetSubjectCode: '',
          budgetSubjectName: '',
          availableBalance: undefined,
          categoriesCode: '',
          detailVos: [],
          budgetControlVos: [],
        });
      }
    },

    // 表单提交
    submit() {
      const formData = this.getFormData();
      console.log(formData);

      // if (formData) {
      //   let url = ''; // 提交的地址
      //   const params = { ...formData };

      //   if (this.formConfig.code === 'edit') {
      //     url = '';
      //     params.id = this.formConfig.row.id;
      //   }

      //   request.post(url, params).then((res) => {
      //     if (res.success) {
      //       this.$message({
      //         type: 'success',
      //         message: '操作成功',
      //       });
      //       this.$emit('onClose');
      //       this.$emit('onGetList');
      //     }
      //   });
      // }
    },
  },
};
